module.exports = __webpack_public_path__ + "static/media/PlutoSansMedium.e251dcd2.ttf";